import VueLoader from '../../vue-loader'
import OrderList from './order_list'

document.addEventListener('turbo:load', () => {
  VueLoader.loadVueComponent(OrderList, document.getElementById('customer_order_list'))
})

export default {}
